export const environmentversion = {
  version : 'origin/Dev1.0(ad189db033b3bc16c148d6be8fe61b07eca00f00)'
};